import { ReactElement, SVGProps } from 'react';
import BaseIcon from './BaseIcon';

export default function EditSquareIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 16 16">
      <path
        d="M6.667 10a.65.65 0 0 1-.475-.192A.65.65 0 0 1 6 9.333V7.717a1.32 1.32 0 0 1 .383-.934l5.734-5.733q.2-.2.45-.3a1.34 1.34 0 0 1 1.008 0q.241.1.442.3l.933.95q.183.2.283.442.1.241.1.491t-.091.492a1.25 1.25 0 0 1-.292.442L9.217 9.6q-.184.184-.425.292T8.283 10zm6.4-6.133.95-.934L13.083 2l-.95.933zM3.333 14q-.55 0-.941-.392A1.28 1.28 0 0 1 2 12.667V3.333q0-.55.392-.941Q2.783 2 3.333 2h4.334q.233 0 .383.117.15.115.233.3a.66.66 0 0 1 .059.366.6.6 0 0 1-.192.35l-3.1 3.1a1.32 1.32 0 0 0-.383.933V10q0 .55.391.942.391.39.942.391h2.817a1.32 1.32 0 0 0 .933-.383l3.117-3.117a.6.6 0 0 1 .35-.191.66.66 0 0 1 .366.058.8.8 0 0 1 .3.233q.117.15.117.384v4.35q0 .55-.392.941a1.28 1.28 0 0 1-.941.392z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
